const classMap = {
  expandableContent: 'js-expandable-content',
  expandableToggle: 'js-expandable-toogle',
}

const mount = () => {
  document.addEventListener('click', ExpandableContent)
}

const ExpandableContent = ({ target }) => {
  const toggleButton = target.closest(`.${classMap.expandableToggle}`)
  if (!toggleButton) return

  const expandableContent = toggleButton.closest(
    `.${classMap.expandableContent}`
  )
  if (!expandableContent) return

  const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true'
  toggleButton.getAttribute('aria-controls')

  expandableContent.classList.toggle('is-opened')
  toggleButton.setAttribute('aria-expanded', String(!isExpanded))
}

export default { mount }
